import { Pie } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { dayAndMonthFormat } from "../../../../utils/dateFormat/dateFormat";
import { formatToDecimal } from "../../../../utils/formatToDecimal/formatToDecimal";

function PieCategory({ categoriesData, date }) {
  const data = {
    labels: categoriesData ? categoriesData.map((data) => data?.descript1) : [],
    datasets: [
      {
        data: categoriesData ? categoriesData.map((data) => data?.total) : [],
        backgroundColor: [
          "#84b6f4",
          "#fdfd96",
          "#77dd77",
          "#ff6961",
          "#fdcae1",
          "#ffda9e",
          "#fcb7af",
          "#b0c2f2",
          "#c5c6c8",
          "#b2e2f2",
        ],
      },
    ],
  };

  const getTotal = () => {
    let total = 0;

    categoriesData.forEach((data) => {
      total += data?.total;
    });

    return total;
  };

  if (categoriesData) {
    if (categoriesData.length > 0) {
      return (
        <div className="pie-container">
          <div className="pie-chart">
            <h4>
              Ventas por Categoría del {dayAndMonthFormat(date?.from)} al{" "}
              {dayAndMonthFormat(date?.to)}
            </h4>
            <Pie className="chart" data={data} />
            <div className="dataDetail">
              {categoriesData.map((data, index) => {
                return (
                  <div key={index}>
                    <label htmlFor="">{data?.descript1}:</label>
                    <p>{formatToDecimal(categoriesData[index]?.total)}</p>
                  </div>
                );
              })}
              <div className="total-chart">
                <label htmlFor="">Total:</label>
                <p>{formatToDecimal(getTotal())}</p>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="pie-container">
          <div className="no-data">
            <FontAwesomeIcon className="icon" icon={faEyeSlash} />
          </div>
        </div>
      );
    }
  } else {
    return (
      <div className="pie-container">
        <div className="no-data">
          <FontAwesomeIcon className="icon" icon={faEyeSlash} />
        </div>
      </div>
    );
  }
}

export default PieCategory;
